import { useTranslation } from "react-i18next";
import { ClipboardText, Clock, TickCircle } from "iconsax-react";
import type { ItemRequestsStats } from "../../../hooks";

interface Props {
  stats: ItemRequestsStats;
}

export default function RequestsStatCards({ stats }: Props) {
  const { t } = useTranslation("WarehouseRequestsPage");

  const cards = [
    { key: "total", label: t("stats.totalRequests"), value: String(stats.totalRequests), subtitle: t("stats.totalRequestsSubtitle"), icon: ClipboardText },
    { key: "active", label: t("stats.activeRequests"), value: String(stats.activeRequests), subtitle: t("stats.activeRequestsSubtitle"), icon: Clock },
    { key: "completed", label: t("stats.completedRequests"), value: String(stats.completedRequests), subtitle: t("stats.completedRequestsSubtitle"), icon: TickCircle },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 gap-2 mb-4">
      {cards.map(function renderCard(card) {
        const Icon = card.icon;
        return (
          <div key={card.key} className="surface-container-fill radius-3xl p-5 flex flex-col gap-3">
            <div className="flex justify-start items-center gap-2">
              <div className="w-8 h-8 radius-xs surface-component-fill flex items-center justify-center content-action-neutral shrink-0">
                <Icon size={16} color="currentColor" />
              </div>
              <p className="text-label-md content-base-primary">{card.label}</p>
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-display-sm content-base-primary">{card.value}</p>
              <p className="text-body-regular-sm content-action-neutral">{card.subtitle}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
